import React from "react";

export default function EstimatedRevenueTotalCard({ value = 0 }) {
  const safe = Number(value || 0);

  return (
    <div className="metric-card">
      <span className="metric-label">Receita estimada total</span>
      <span className="metric-value">
        R$ {safe.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
      </span>
      <span className="metric-tag">estimativa mensal (todos os planos)</span>
    </div>
  );
}
